import { HStack, Text } from "@chakra-ui/layout";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { FaAngleRight } from "react-icons/fa";
import { FcFolder } from "react-icons/fc";
import colors from "resources/theme/colors";

interface BreadcrumbDocsProps {
  onSelectPasta: (id?: string) => void;
  breadCrumb: {
    id: string;
    name: string;
  }[];
}

function BreadcrumbDocs({ onSelectPasta, breadCrumb }: BreadcrumbDocsProps) {
  return (
    <Breadcrumb
      my="1rem"
      spacing="8px"
      separator={<FaAngleRight color="rgba(0,0,0,0.5)" />}
    >
      {breadCrumb.map((item, index) => (
        <BreadcrumbItem
          fontSize="15px"
          color="black"
          key={index}
          isCurrentPage={breadCrumb.length - 1 === index}
        >
          <BreadcrumbLink
            _hover={{ color: colors.blue }}
            fontSize="13px"
            cursor={"pointer"}
            color={breadCrumb.length - 1 === index ? colors.blue : "black"}
            onClick={() =>
              breadCrumb.length - 1 === index
                ? undefined
                : onSelectPasta(item.id)
            }
          >
            <HStack spacing="2px">
              <FcFolder /> <Text>{item.name} </Text>
            </HStack>
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}

export default BreadcrumbDocs;
